import type { UserPreferencesProvider } from '@atlaskit/editor-common/user-preferences';
import type { UserPreferencesPluginOptions } from '@atlaskit/editor-plugin-user-preferences';

interface Props {
	providers: {
		userPreferencesProviderNext?: UserPreferencesProvider;
	};
}

export function userPreferencesPluginOptions({ providers }: Props): UserPreferencesPluginOptions {
	return {
		userPreferencesProvider: providers.userPreferencesProviderNext,
		initialUserPreferences: undefined, // This will be set by the userPreferencesProvider if available;
	};
}
